import { TableColumn } from './EventsTableHeader.types';

export const eventsTableColumns: TableColumn[] = [
  {
    label: 'EVENT TYPE',
    width: 'w-[22%]',
    sortable: true,
    sortKey: 'eventType',
  },
  {
    label: 'SEVERITY',
    width: 'w-[11%]',
    sortable: true,
    sortKey: 'changeImpact',
  },
  {
    label: 'DESCRIPTION',
    width: 'w-[18%]',
    sortable: true,
    sortKey: 'message',
  },
  {
    label: 'REPOSITORY NAME',
    width: 'w-[20%]',
    sortable: true,
    sortKey: 'resource',
  },
  {
    label: 'USER',
    width: 'w-[16%]',
    sortable: true,
    sortKey: 'userId',
  },
  {
    label: 'DATE',
    width: 'w-[13%]',
    sortable: true,
    sortKey: 'createdAt',
  },
];
